// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__QvSC6","log":"ModalInventoryLogs_log__3VRyW","date":"ModalInventoryLogs_date__1Dg1T","userName":"ModalInventoryLogs_userName__20wIR"};